import React from 'react';
import labLogo from '../Images/LabLogo.png';

const Header = () => (
  <header className="header">
    <div className="header-content">
      <a href="https://www.ramonsunlab.com/" target="_blank" rel="noopener noreferrer">
        <img src={labLogo} className="logo" alt="Sun Lab Logo" />
      </a>
      <div className="header-title">
        <h1>UF | Sun Laboratory</h1>
        <p>Department of Biochemistry & Molecular Biology in the College of Medicine</p>
      </div>
    </div>
  </header>
);

export default Header;
